import LessonDetail from './component'
export default LessonDetail
